var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{staticClass:"calculation-result__row"},[_c('td',{staticClass:"calculation-result__cell"},[_vm._t("description")],2),_c('td',{staticClass:"calculation-result__cell"},[_vm._t("value")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }